/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SuiviFichierGridDto
 */
export interface SuiviFichierGridDto {
    /**
     * 
     * @type {number}
     * @memberof SuiviFichierGridDto
     */
    idsuiviFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof SuiviFichierGridDto
     */
    idtypeSuiviFichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviFichierGridDto
     */
    typeSuiviFichier?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviFichierGridDto
     */
    idfichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviFichierGridDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviFichierGridDto
     */
    uploadUser?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviFichierGridDto
     */
    creationUserName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SuiviFichierGridDto
     */
    uploadDate?: Date | null;
}

/**
 * Check if a given object implements the SuiviFichierGridDto interface.
 */
export function instanceOfSuiviFichierGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SuiviFichierGridDtoFromJSON(json: any): SuiviFichierGridDto {
    return SuiviFichierGridDtoFromJSONTyped(json, false);
}

export function SuiviFichierGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuiviFichierGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsuiviFichier': !exists(json, 'idsuiviFichier') ? undefined : json['idsuiviFichier'],
        'idtypeSuiviFichier': !exists(json, 'idtypeSuiviFichier') ? undefined : json['idtypeSuiviFichier'],
        'typeSuiviFichier': !exists(json, 'typeSuiviFichier') ? undefined : json['typeSuiviFichier'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'uploadUser': !exists(json, 'uploadUser') ? undefined : json['uploadUser'],
        'creationUserName': !exists(json, 'creationUserName') ? undefined : json['creationUserName'],
        'uploadDate': !exists(json, 'uploadDate') ? undefined : (json['uploadDate'] === null ? null : new Date(json['uploadDate'])),
    };
}

export function SuiviFichierGridDtoToJSON(value?: SuiviFichierGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsuiviFichier': value.idsuiviFichier,
        'idtypeSuiviFichier': value.idtypeSuiviFichier,
        'typeSuiviFichier': value.typeSuiviFichier,
        'idfichier': value.idfichier,
        'fileName': value.fileName,
        'uploadUser': value.uploadUser,
        'creationUserName': value.creationUserName,
        'uploadDate': value.uploadDate === undefined ? undefined : (value.uploadDate === null ? null : value.uploadDate.toISOString()),
    };
}

